import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IUser } from 'src/app/interface/user';
import { IGroup } from 'src/app/interface/group';
import { ChatterType } from 'src/app/interface/chat';

@Component({
	selector: 'app-avatar',
	templateUrl: './avatar.component.html',
	styleUrls: ['./avatar.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarComponent {
	@Input()
	public data: IUser | IGroup | undefined;
	@Input()
	public size: string = 'regular';
	@Input()
	public type: ChatterType  | undefined;
	@Input()
	public favorite: boolean = false;

	public get isGroup(): boolean {
		return this.type === ChatterType.Group;
	}

	public imageError() {
		this.data!.avatar_url = "";
	}
}
